<template>
  <div>
    <el-card class="box-card">
      <div class="title mt20">备注记录</div>
      <div v-for="item in listbeizhulog" :key="item.Id">
        <li>[{{item.Createtime}}] {{item.Beizhu}}</li>
      </div>
    </el-card>
    <el-card class="box-card">
      <div class="title mt20">发货</div>
      <el-form :model="dlsorderinvoice" ref="dlsorderinvoiceRef" label-width="82px">
        <el-form-item v-for="(item,index) in dlsorderinvoice.optionsproduct" label="" class="addAdminForm">
          <div class="productdata1">
            <div class="productdata2">
              产品名称:
              <el-input v-model="item.Name" placeholder="" style="width: 30%"></el-input>
              数量:
              <el-input v-model="item.Num" placeholder="" style="width: 30%"></el-input>
            </div>
          </div>
        </el-form-item>
        <el-form-item label="配送方式" class="addAdminForm">
          <el-select v-model="dlsorderinvoice.sendtype" placeholder="请选择" style="width: 100%">
            <el-option label="邮寄" value="0"></el-option>
            <el-option label="上门自提" value="1"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="物流公司" class="addAdminForm" v-if="dlsorderinvoice.sendtype == 0">
          <el-input v-model="dlsorderinvoice.logisticsname" placeholder=""></el-input>
        </el-form-item>
        <el-form-item label="物流单号" class="addAdminForm" v-if="dlsorderinvoice.sendtype == 0">
          <el-input v-model="dlsorderinvoice.logisticsid" placeholder=""></el-input>
        </el-form-item>

        <el-form-item class="mt20">
          <el-button type="primary" @click="clicksave">发货</el-button>
          <el-button type="info" @click="clickback">返回</el-button>
        </el-form-item>
      </el-form>

      <div class="title mt20">发货记录</div>
      <el-table :data="listlog" border stripe class="mt15">
        <el-table-column prop="Productlist" label="清单" min-width="25%"></el-table-column>
        <el-table-column prop="Statuss" label="状态" min-width="5%"></el-table-column>
        <el-table-column prop="Sendtypes" label="配送方式" min-width="5%"></el-table-column>
        <el-table-column prop="Logisticsname" label="物流公司" min-width="10%"></el-table-column>
        <el-table-column prop="Logisticsid" label="物流单号" min-width="10%"></el-table-column>
        <el-table-column prop="" label="回执单" min-width="10%">
          <template v-slot="scope">
            <img :src="scope.row.Receiptsimage" min-width="48" height="48" />
          </template>
        </el-table-column>
        <el-table-column prop="Createusername" label="发货人" min-width="5%"></el-table-column>
        <el-table-column prop="Receivedusername" label="签收人" min-width="5%"></el-table-column>
        <el-table-column prop="Createtime" label="操作时间" min-width="15%"></el-table-column>
        <el-table-column prop="operation" label="操作" min-width="10%">
          <template v-slot="scope">
            <el-button type="text" size="mini" style="margin-left: 0; margin-right: 5px" v-if="scope.row.Status == 0" @click="cilckimagesenddialog(scope.row)">上传回执单</el-button>
            <el-button type="text" size="mini" style="margin-left: 0; margin-right: 5px" v-if="SubRule_ErpDlsOrder_DeleteLogistics" @click="clickdelete(scope.row)">删除</el-button>
          </template>
        </el-table-column>
      </el-table>

    </el-card>

    <!-- 提交回执单弹出框 -->
    <el-dialog title="提交回执单" :visible.sync="imagesenddialog" width="30%" :close-on-click-modal="false">
      <el-form :model="imagesendForm" ref="imagesendFormRef" label-width="120px">
        <el-form-item label="回执单" class="addAdminForm">
          <TencentyunCosUploadImg :propsimageUrl="imagesendForm.receiptsimage" @change="addTencentyunCosUploadImg"></TencentyunCosUploadImg>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="clicksaveimage">提交</el-button>
        </el-form-item>
      </el-form>
    </el-dialog>
    <!-- 提交支付凭证弹出框 end -->

  </div>
</template>

<script>
import Vue from 'vue'
import axios from 'axios'
import VueAxios from 'vue-axios'
import Qs from 'qs'
import TencentyunCosUploadImg from '@/components/TencentyunCosUploadImg.vue'
Vue.use(VueAxios, axios)

export default {
  components: {
    TencentyunCosUploadImg
  },
  data () {
    return {
      imagesenddialog: false,
      imagesendForm: {
        id: '',
        receiptsimage: ''
      },
      dlsorderinvoice: {
        optionsproduct: [],
        sendtype: '0',
        logisticsname: '',
        logisticsid: ''
      },
      listlog: [],
      listbeizhulog: [],
      orderid: null,
      jigouid: null,
      SubRule_ErpDlsOrder_DeleteLogistics: false
    }
  },
  methods: {
    LoadData (parentdata) {
      this.orderid = parentdata.params.orderid
      this.jigouid = parentdata.params.jigouid
      this.apiGetDlsOrderSubWithOrderid()
      this.apiGeterporderinvoicelist()
      this.apiGeterporderbeizhulist()

      var that = this
      Vue.prototype.FunCheckSubRule('SubRule_ErpDlsOrder_DeleteLogistics', function (response) {
        if (response.data.Code === 200) {
          that.SubRule_ErpDlsOrder_DeleteLogistics = true
        }
      })
    },
    addTencentyunCosUploadImg (url) {
      this.imagesendForm.receiptsimage = url
    },
    clickback () {
      this.$emit('triggerFunc', '')
    },
    clicksave () {
      this.apiAddproductorderinvoice()
    },
    clicksaveimage () {
      if (!this.imagesendForm.receiptsimage) {
        this.$alert('请选择回执单', '提示')
        return
      }
      this.apiEditerporderreceiptsimage()
    },
    cilckimagesenddialog (row) {
      this.imagesendForm.sendid = row.Sendid
      this.imagesenddialog = true
    },
    clickdelete (row) {
      this.$confirm('是否删除此发货记录?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.DeleteErpOrderInvoice(row.Orderid, row.Sendid)
      })
    },
    apiGetDlsOrderSubWithOrderid: function () {
      var that = this
      var useriderp = localStorage.getItem('Useriderp')
      var timestamp = Date.parse(new Date()) / 1000
      var data = {
        os: 'erp',
        useriderp: useriderp,
        timestamp: timestamp,
        localfingerprint: Vue.prototype.FunGetLocalFingerprint(),
        orderid: this.orderid
      }
      // 加上签名
      data.sign = Vue.prototype.FunGetSignErp(data)
      axios.post(Vue.prototype.global.Url_GetDlsOrderSubWithOrderid, Qs.stringify(data))
        .then(function (response) {
          if (response.data.Code === 200) {
            that.dlsorderinvoice.optionsproduct = response.data.List
          }
          Vue.prototype.FunCheckApiCodeBackground(response.data)
        })
        .catch(function (error) {
          Vue.prototype.FunLogError(error)
        })
    },
    apiAddproductorderinvoice: function () {
      var that = this
      var useriderp = localStorage.getItem('Useriderp')
      var timestamp = Date.parse(new Date()) / 1000
      var data = {
        os: 'erp',
        useriderp: useriderp,
        timestamp: timestamp,
        localfingerprint: Vue.prototype.FunGetLocalFingerprint(),
        orderid: this.orderid,
        jigouid: this.jigouid,
        productlist: JSON.stringify(this.dlsorderinvoice.optionsproduct),
        sendtype: this.dlsorderinvoice.sendtype,
        logisticsname: this.dlsorderinvoice.logisticsname,
        logisticsid: this.dlsorderinvoice.logisticsid
      }
      // 加上签名
      data.sign = Vue.prototype.FunGetSignErp(data)
      axios.post(Vue.prototype.global.Url_Addproductorderinvoice, Qs.stringify(data))
        .then(function (response) {
          if (response.data.Code === 200) {
            that.apiGeterporderinvoicelist()
          }
          Vue.prototype.FunCheckApiCodeBackground(response.data)
        })
        .catch(function (error) {
          Vue.prototype.FunLogError(error)
        })
    },
    apiGeterporderinvoicelist: function (type, parentid) {
      var that = this
      var useriderp = localStorage.getItem('Useriderp')
      var timestamp = Date.parse(new Date()) / 1000
      var data = {
        os: 'erp',
        useriderp: useriderp,
        timestamp: timestamp,
        localfingerprint: Vue.prototype.FunGetLocalFingerprint(),
        orderid: this.orderid
      }
      // 加上签名
      data.sign = Vue.prototype.FunGetSignErp(data)
      axios.post(Vue.prototype.global.Url_Geterporderinvoicelist, Qs.stringify(data))
        .then(function (response) {
          if (response.data.Code == 200) {
            that.listlog = response.data.List
          }
          Vue.prototype.FunCheckApiCodeBackground(response.data)
        })
        .catch(function (error) {
          Vue.prototype.FunLogError(error)
        })
    },
    apiEditerporderreceiptsimage: function () {
      var that = this
      var useriderp = localStorage.getItem('Useriderp')
      var timestamp = Date.parse(new Date()) / 1000
      var data = {
        os: 'erp',
        useriderp: useriderp,
        timestamp: timestamp,
        localfingerprint: Vue.prototype.FunGetLocalFingerprint(),
        receiptsimage: this.imagesendForm.receiptsimage,
        sendid: this.imagesendForm.sendid
      }
      // 加上签名
      data.sign = Vue.prototype.FunGetSignErp(data)
      axios.post(Vue.prototype.global.Url_Editerporderreceiptsimage, Qs.stringify(data))
        .then(function (response) {
          that.apiGeterporderinvoicelist()
          Vue.prototype.FunCheckApiCodeWithCallback(response.data, true, function () {
            that.imagesenddialog = false
          })
        })
        .catch(function (error) {
          Vue.prototype.FunLogError(error)
        })
    },
    apiGeterporderbeizhulist: function (type, parentid) {
      var that = this
      var useriderp = localStorage.getItem('Useriderp')
      var timestamp = Date.parse(new Date()) / 1000
      var data = {
        os: 'erp',
        useriderp: useriderp,
        timestamp: timestamp,
        localfingerprint: Vue.prototype.FunGetLocalFingerprint(),
        orderid: this.orderid
      }
      // 加上签名
      data.sign = Vue.prototype.FunGetSignErp(data)
      axios.post(Vue.prototype.global.Url_Geterporderbeizhulist, Qs.stringify(data))
        .then(function (response) {
          if (response.data.Code == 200) {
            that.listbeizhulog = response.data.List
          }
          Vue.prototype.FunCheckApiCodeBackground(response.data)
        })
        .catch(function (error) {
          Vue.prototype.FunLogError(error)
        })
    },
    DeleteErpOrderInvoice: function (orderid, sendid) {
      var that = this
      var useriderp = localStorage.getItem('Useriderp')
      var timestamp = Date.parse(new Date()) / 1000
      var data = {
        os: 'erp',
        useriderp: useriderp,
        timestamp: timestamp,
        localfingerprint: Vue.prototype.FunGetLocalFingerprint(),
        orderid: orderid,
        sendid: sendid
      }
      // 加上签名
      data.sign = Vue.prototype.FunGetSignErp(data)
      axios.post(Vue.prototype.global.Url_DeleteErpOrderInvoice, Qs.stringify(data))
        .then(function (response) {
          if (response.data.Code === 200) {
            that.apiGeterporderinvoicelist()
          }
          Vue.prototype.FunCheckApiCodeBackground(response.data)
        })
        .catch(function (error) {
          Vue.prototype.FunLogError(error)
        })
    }
  }
}
</script>

<style lang="less" scoped>
.select1 {
    width: 109px;
    margin-right: 15px;
}
.speed {
    width: 440px;
    margin-right: 15px;
}
</style>
